module.exports = __webpack_public_path__ + "static/icon_color_food-10cef186a9c7983be8948e73a5830030.png";